import React, { useState } from "react";
import Cameralist from "./Cameralist";
import { TbPolygon } from "react-icons/tb";
import { toast } from "react-toastify";

export default function Stp2Event({
  formData = { camera_ids: [] },
  setFormData,
  drawMode,
  setDrawMode,
  polygonName,
  setPolygonName, // now coming from parent
}) {
  const [showCamera, setShowCamera] = useState(false);

  return (
    <>
      <h4>Cameras</h4>
      <p className="formTitle mt-3 mb-4">
        Select camera / camera group for this event from the drawer on the
        right.
      </p>

      <div className="d-flex align-items-center gap-4">
        <button className="mainBlue3 px-5" onClick={() => setShowCamera(true)}>
          Camera Select
        </button>
        <p className="cameraSelect m-0">
          {formData?.camera_ids?.length || 0} Camera selected
        </p>
      </div>

      {formData?.camera_ids?.length > 0 && (
        <div className="mt-4">
          <p className="mb-2">Choose Drawing Mode:</p>
          <div className="d-flex gap-3 align-items-center">
            <label className="fw-bold">Employee Name</label>
            <input
              value={polygonName}
              onChange={(e) => setPolygonName(e.target.value)}
              placeholder="Enter polygon name"
            />

            <button
              className="draw-btn mt-2"
              onClick={() => {
                if (!polygonName.trim()) {
                  toast.error("Please enter a polygon name before drawing!");
                  return;
                }
                setDrawMode("polygon");
              }}
            >
              🔺 Click to draw polygon on video
            </button>
          </div>
        </div>
      )}

      {drawMode && (
        <div className="startDrawing mt-4">
          <div className="d-flex gap-2">
            <TbPolygon size={26} /> Click anywhere on the zoomed camera to start
            drawing a <strong>{drawMode}</strong>.
          </div>
        </div>
      )}

      {showCamera && (
        <Cameralist
          setShowCamera={setShowCamera}
          formData={formData}
          setFormData={setFormData}
        />
      )}
    </>
  );
}
